import { render, staticRenderFns } from "./odeme.vue?vue&type=template&id=56d47edc&"
import script from "./odeme.vue?vue&type=script&lang=js&"
export * from "./odeme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports